import { Navigate, useLocation } from 'react-router-dom';

import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { AppRoute } from '../AppRoute.enum';
import { Loader } from 'ui/loader/Loader';

import { MultiPermissionsRouteProps } from './MultiPermissionsRoute.types';

export const MultiPermissionsRoute = ({ children, permissions }: MultiPermissionsRouteProps) => {
  const { perms } = usePermissions();
  const location = useLocation();

  if (!perms) {
    return <Loader />;
  }

  const hasAnyPermission = permissions.some((permission) => perms[permission]?.view);

  if (hasAnyPermission) {
    return children;
  }

  return (
    <Navigate
      to={{ pathname: AppRoute.profile }}
      state={{
        // Keep the query string: DOD monitor deep links (?range=6h&rcp=...) and ?openAddLicense=true
        // are part of the destination, and a hard reload passes through this redirect.
        destinationLink: `${location.pathname}${location.search}`,
        prevPath: location?.state?.prevPath,
      }}
    />
  );
};
